/* eslint-disable no-console */

import { shouldLogError } from './errorHandling';

enum ELogLevel {
  Debug = 0,
  Info = 1,
  Warn = 2,
  Error = 3
}

class Logger {
  private static logLevel: ELogLevel = import.meta.env.PROD
    ? ELogLevel.Info
    : ELogLevel.Debug;

  static init(): void {}

  private static shouldLog(level: ELogLevel): boolean {
    return level >= Logger.logLevel;
  }

  static debug(message: string, ...args: any): void {
    if (Logger.shouldLog(ELogLevel.Debug)) {
      console.debug(`[DEBUG]: ${message}`, ...args);
    }
  }

  static info(message: string, ...args: any): void {
    if (Logger.shouldLog(ELogLevel.Info)) {
      console.info(`[INFO]: ${message}`, ...args);
    }
  }

  static warn(message: string, ...args: any): void {
    if (Logger.shouldLog(ELogLevel.Warn)) {
      console.warn(`[WARN]: ${message}`, ...args);
    }
  }

  static error(message: string, ...args: any): void {
    const errorObject: Error | undefined = args.find(
      (arg: any) => arg instanceof Error
    );
    if (
      Logger.shouldLog(ELogLevel.Error) &&
      (!errorObject || shouldLogError(errorObject))
    ) {
      console.error(`[ERROR]: ${message}`, ...args);
    }
  }

  static getLogLevel(): ELogLevel {
    return Logger.logLevel;
  }
}

export { Logger, ELogLevel };
